"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HamburgerButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const icon_button_utils_1 = require("@/components/common/icon-button/icon-button.utils");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * 사이드바/내비게이션 메뉴를 여닫는 햄버거 버튼.
 */
let HamburgerButton = class HamburgerButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.ariaLabel = '전체 메뉴';
        this.ariaExpanded = 'false';
        this.ariaControls = null;
    }
    render() {
        return (0, icon_button_utils_1.renderIconAction)({
            icon: icon_names_1.ICON_NAMES.MENU,
            ariaLabel: this.ariaLabel,
            ariaExpanded: this.ariaExpanded,
            ariaControls: this.ariaControls,
        });
    }
};
HamburgerButton.styles = [
    shared_styles_1.resetStyles,
    icon_button_styles_1.iconButtonStyles,
    (0, lit_1.css) `
      :host {
        ${(0, icon_button_styles_1.iconButtonVariantSkin)('ghost')}
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], HamburgerButton.prototype, "ariaLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-expanded' })
], HamburgerButton.prototype, "ariaExpanded", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-controls' })
], HamburgerButton.prototype, "ariaControls", void 0);
HamburgerButton = __decorate([
    (0, decorators_js_1.customElement)('mm-hamburger-button')
], HamburgerButton);
exports.HamburgerButton = HamburgerButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFtYnVyZ2VyLWJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImhhbWJ1cmdlci1idXR0b24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXFDO0FBQ3JDLHFEQUEyRDtBQUkzRCxvRUFBZ0U7QUFDaEUsMkZBRzJEO0FBQzNELHlGQUFvRjtBQUNwRiwrREFBeUQ7QUFFekQ7O0dBRUc7QUFFSSxJQUFNLGVBQWUsR0FBckIsTUFBTSxlQUFnQixTQUFRLGdCQUFVO0lBQXhDOztRQVVnRCxjQUFTLEdBQUcsT0FBTyxDQUFBO1FBQ2hCLGlCQUFZLEdBQWdCLE9BQU8sQ0FBQTtRQUNuQyxpQkFBWSxHQUFjLElBQUksQ0FBQTtJQVV4RixDQUFDO0lBUkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxvQ0FBZ0IsRUFBQztZQUN0QixJQUFJLEVBQUUsdUJBQVUsQ0FBQyxJQUFJO1lBQ3JCLFNBQVMsRUFBRSxJQUFJLENBQUMsU0FBUztZQUN6QixZQUFZLEVBQUUsSUFBSSxDQUFDLFlBQVk7WUFDL0IsWUFBWSxFQUFFLElBQUksQ0FBQyxZQUFZO1NBQ2hDLENBQUMsQ0FBQTtJQUNKLENBQUM7O0FBcEJNLHNCQUFNLEdBQUc7SUFDZCwyQkFBVztJQUNYLHFDQUFnQjtJQUNoQixJQUFBLFNBQUcsRUFBQTs7VUFFRyxJQUFBLDBDQUFxQixFQUFDLE9BQU8sQ0FBQzs7S0FFbkM7Q0FDRixDQUFBO0FBQ29EO0lBQXBELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLFlBQVksRUFBRSxDQUFDO2tEQUFvQjtBQUNoQjtJQUF2RCxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLFNBQVMsRUFBRSxlQUFlLEVBQUUsQ0FBQztxREFBb0M7QUFDbkM7SUFBdkQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsZUFBZSxFQUFFLENBQUM7cURBQStCO0FBWjNFLGVBQWU7SUFEM0IsSUFBQSw2QkFBYSxFQUFDLHFCQUFxQixDQUFDO0dBQ3hCLGVBQWUsQ0FzQjNCO0FBdEJZLDBDQUFlIn0=